<template>
  <!-- 头部区域 -->
  <div class="header">
    <div class="header-section">
      <div class="container">
        <div class="header-wrapper">
          <div class="logo-menu">
            <a href="/" class="logo">
              <img src="/assets/logo.png" style="min-width: 220px; object-fit: contain;" alt="logo">
            </a>
          </div>
          <div class="header-bar d-xl-none">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul class="main-menu">
            <li v-for="(item, index) in mainMenu" :key="index" :class="item.class || ''">
              <template v-if="item.isButton">
                <a @click="showContact"><span>{{ item.name }}</span> <i v-if="item.icon" :class="item.icon"></i></a>
              </template>
              <template v-else>
                <a v-if="!item.children" :id="item.id" :href="localePath(item.path)">{{ item.name }} <i v-if="item.icon"
                    :class="item.icon"></i></a>
                <a v-else :id="item.id">{{ item.name }} <i v-if="item.icon"
                    :class="item.icon"></i></a>
                <ul v-if="item.children" class="sub-menu">
                  <li v-for="(child, childIndex) in item.children" :key="childIndex" :class="child.class || ''">
                    <a :href="localePath(child.path)">{{ child.name }} <i v-if="child.icon" :class="child.icon"></i></a>
                    <ul v-if="child.children" class="sub_sub_menu">
                      <li v-for="(subChild, subChildIndex) in child.children" :key="subChildIndex">
                        <a :href="localePath(subChild.path)">{{ subChild.name }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </template>
            </li>
            <!-- 语言切换按钮 -->
            <li class="relative group ml-[20px] mr-[20px]">
              <a href="#" class="flex items-center">
                <img src="/assets/images/icon/language.svg" class="w-[20px] h-[20px] mr-2">
                {{ currentLangName }}
                <i class="fa-solid fa-chevron-down ms-1 primary-color"></i>
              </a>
              <ul class="sub-menu">
                <li v-for="(lang, index) in langList" :key="index">
                  <a href="#" @click.prevent="switchLanguage(lang.code)">
                    {{ lang.name }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- 移动端语言切换 -->
  <div class="mobile-lang-switch d-xl-none">
    <div class="container">
      <div class="d-flex justify-content-end py-2 border-bottom">
        <div class="mobile-menu-item" :class="{ 'active': isMobileLangOpen }">
          <a href="#" class="d-flex align-items-center" @click.prevent="toggleMobileLang">
            <img src="/assets/images/icon/language.svg" class="w-[20px] h-[20px] mr-2">
            {{ currentLangName }}
            <i class="fa-solid fa-chevron-down ms-2 primary-color"></i>
          </a>
          <ul class="mobile-submenu" v-if="isMobileLangOpen">
            <li v-for="(lang, index) in langList" :key="index">
              <a href="#" @click.prevent="switchLanguage(lang.code)">
                {{ lang.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
const localePath = useLocalePath()
const { locale, setLocale, t } = useI18n();

// 使用 useI18n 获取菜单数据
const mainMenu = ref([
  {
    name: t('pk36qk'),
    path: '/',
  },
  {
    name: t('x0zeot'),
    path: '/solutions/battery-swap',
    icon: 'fas fa-chevron-down',
    children: [
      { name: t('hg5mno'), path: '/solutions/battery-swap' },
      { name: t('11h3u1'), path: '/solutions/storage-cabinet' },
      { name: t('ydwsx2'), path: '/solutions/charging-station' }
    ]
  },
  {
    name: t('5xblq2'),
    path: '/products/charger',
    icon: 'fas fa-chevron-down',
    children: [
      { name: t('5gl97d'), path: '/products/charger' },
      { name: t('ydwsx2'), path: '/products/charging-station' },
      { name: t('hg5mno'), path: '/products/battery-swap' },
      { name: t('11h3u1'), path: '/products/storage-cabinet' }
    ]
  },
  {
    name: t('g2z9ql'),
    path: '/services/faq',
    icon: 'fas fa-chevron-down',
    children: [
      { name: t('pq3riz'), path: '/services/faq' },
      { name: t('6kz6k1'), path: '/services/doc' }
    ]
  },
  { name: t('g687nj'), path: '/news' },
  { name: t('hzg74n'), path: '/case' },
  { name: t('5x747l'), path: '/contact' },
  { name: t('3kc6tv'), path: '/about' },
  {
    name: t('nxi2s8'),
    path: '/contact',
    icon: 'fa-solid fa-angles-right',
    class: 'm-0 menu-btn',
    isButton: true
  }
])

// 获取语言列表
const { data: languageList } = await useFetch('/sre/i18n/enabled_language/public', {
  baseURL: useRuntimeConfig().public.apiUrl
});

// 格式化语言列表
const langList = computed(() => {
  if (!languageList.value || !languageList.value.data) return [];
  return languageList.value.data.map(v => ({
    code: v.value,
    name: v.nativeName
  }));
});

// 获取当前语言名称
const currentLangName = computed(() => {
  return langList.value.find(v => v.code === locale.value)?.name || '中文 (简体)';
});

// 移动端语言下拉状态
const isMobileLangOpen = ref(false);

// 切换移动端语言下拉菜单
const toggleMobileLang = () => {
  isMobileLangOpen.value = !isMobileLangOpen.value;
};

// 切换语言
const switchLanguage = (langCode) => {
  setLocale(langCode);
  isMobileLangOpen.value = false;
  setTimeout(() => {
    window.location.reload();
  }, 300);
};

const showContact = () => {
  console.log('showContact')

  // 确保只在客户端执行
  if (import.meta.browser) {
    // Tawk_API.toggle()
    // // 尝试方法 2: 直接操作 iframe
    // const chatIframe = document.getElementById('s-chat-plugin')
    // console.log('聊天 iframe:', chatIframe)

    // if (chatIframe) {
    //   // 尝试方法 2.1: 尝试触发点击事件
    //   try {
    //     // 如果 iframe 和主页面同源，可以直接访问其内容
    //     const iframeDocument = chatIframe.contentDocument || chatIframe.contentWindow.document
    //     const chatButton = iframeDocument.querySelector('.view_btn_chat_pglag')

    //     if (chatButton) {
    //       console.log('在 iframe 中找到聊天按钮，尝试点击')
    //       chatButton.click()
    //       return
    //     }
    //   } catch (e) {
    //     console.log('无法访问 iframe 内容，可能是跨域限制:', e)
    //   }
    // }
  }
}
</script>
